import { useSnackbar } from "notistack";
import { globalDeleteService, globalGetService, globalPostService, globalPutService } from "../../../utils/globalApiServices";
import { addClaimApi, addShopVisitApi, claimFileUploadPostApi, deleteShopvisitApi, getConsantApi, getShopVisitApi, getShopVisitUserApi, shopVisitFileUploadPostApi, updateClaimApi, updateShopVisitApi } from "../apiServices";
import { checkApiStatus } from "../../../utils";
import { trackActivity } from "../../../utils/mixpanel";

export const useGetApiHook = (params) => {
    const getUserList = async (toggleLoader) => {
        toggleLoader("pageLoader", true)
        const response = await globalGetService(getShopVisitUserApi())
        if (checkApiStatus(response)) {
            toggleLoader("pageLoader", false)
            return response?.data?.data
        } else {
            toggleLoader("pageLoader", false)
            return null
        }
    }
  
    const getPltConstants = async (toggleLoader) => {
        const response = await globalPostService(getConsantApi(), { 'constant_types': ['shop_visit_status'] })
        if (checkApiStatus(response)) {
            toggleLoader("pageLoader", false)
            return response?.data?.data
        } else {
            toggleLoader("pageLoader", false)
            return null
        }
    }
    return ({ getUserList,  getPltConstants })
}


export const useShopVisitActions = (params) => {
    const { enqueueSnackbar } = useSnackbar()
    const saveShopVisit = async (assetData, shopVisit, updatedPayload, toggleLoader, silentSuccess = false) => {
        toggleLoader("buttonLoader", true)
        const apiPromise = shopVisit?.id ? globalPutService(updateShopVisitApi(shopVisit?.slug,params?.leaseSlug), updatedPayload) : globalPostService(addShopVisitApi(assetData?.slug,params?.leaseSlug), updatedPayload);
        const response = await apiPromise;
        const formatToastMessage = (message) => {
            if (Array.isArray(message)) {
              return (
                <div>
                  {message?.map((m, i) => (
                    <div key={i} style={{ display: "flex", alignItems: "flex-start", marginBottom: 4 }} >
                      <span style={{ fontSize: 18, lineHeight: "18px", marginRight: 8 }} > ● </span>
                      <span>{m}</span>
                    </div>
                  ))}
                </div>
              );
            }
            return message;
          };
        if (checkApiStatus(response)) {
            toggleLoader("buttonLoader", false)
            if (!silentSuccess) enqueueSnackbar(response?.data?.message, { variant: "success",hideIconVariant:true, anchorOrigin: { horizontal: "right", vertical: "top" } });
            trackActivity(`Item ${shopVisit?.id ? 'Edited' : 'Added'}`, { page_title: `${shopVisit?.id ? 'Edit' : 'Add'} Shop Visit`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: updatedPayload, response: response?.data })
            return response?.data?.data
        } else {
            enqueueSnackbar(formatToastMessage(response?.data?.message), { variant: "error",hideIconVariant:true, anchorOrigin: { horizontal: "right", vertical: "top" } });
            toggleLoader("buttonLoader", false)
            trackActivity(`Item ${shopVisit?.id ? 'Edited' : 'Added'}`, { page_title: `${shopVisit?.id ? 'Edit' : 'Add'} Shop Visit`, error_msg: response?.data?.message, item_id: shopVisit?.id || null, payload: updatedPayload, response: response?.data })
            return null
        }
    };
    const deleteShopVisitFnc = async (assetData, idsToDelete, toggleLoader) => {
        toggleLoader("buttonLoader", true)
        const response = await globalDeleteService(deleteShopvisitApi(assetData?.slug), idsToDelete)
        if (checkApiStatus(response)) {
            trackActivity('Item Deleted', { page_title: `Delete Shop Visit`, success_msg: response?.data?.message, item_ids: idsToDelete, response: response?.data })
            toggleLoader("buttonLoader", false)
            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
            return response
        } else {
            toggleLoader("buttonLoader", false)
            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
            trackActivity('Item Deleted', { page_title: `Delete Shop Visit`, error_msg: response?.data?.message, item_ids: idsToDelete, response: response?.data })
            return null
        }
    };
   
    const uploadFiles = async (shopVisitSlug, attachedFiles, getResponseBack) => {
        let formData = new FormData();
        if (attachedFiles?.length) { attachedFiles.map(item => { formData.append('files', item) }) }
        globalPostService(shopVisitFileUploadPostApi(shopVisitSlug), formData)
            .then(response => {
                if (checkApiStatus(response)) {
                    getResponseBack();
                    // enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
                } else {
                    // enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
                }
            })
    };
    return { saveShopVisit, uploadFiles, deleteShopVisitFnc, };
}
export const useClaimActions = (params,toggleLoader) => {
    const { enqueueSnackbar } = useSnackbar()
    const saveClaim = async (assetData,  updatedPayload) => {
        toggleLoader("buttonLoader", true)
        const apiPromise = updatedPayload?.id ? globalPutService(updateClaimApi(params,assetData), updatedPayload) : globalPostService(addClaimApi(params,assetData), updatedPayload);
        const response = await apiPromise;
        if (checkApiStatus(response)) {
            toggleLoader("buttonLoader", false)
            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
            trackActivity(`Item ${updatedPayload?.id ? 'Edited' : 'Added'}`, { page_title: `${updatedPayload?.id ? 'Edit' : 'Add'} Shop Visit Claim`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: updatedPayload, response: response?.data })
            return response?.data?.data
        } else {
            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
            toggleLoader("buttonLoader", false)
            trackActivity(`Item ${updatedPayload?.id ? 'Edited' : 'Added'}`, { page_title: `${updatedPayload?.id ? 'Edit' : 'Add'} Shop Visit Claim`, error_msg: response?.data?.message, item_id: updatedPayload?.id || null, payload: updatedPayload, response: response?.data })
            return null
        }
    };
    const deleteClaimFnc = async (assetData, idsToDelete) => {
        toggleLoader("buttonLoader", true)
        const response = await globalDeleteService(deleteShopvisitApi(assetData?.slug), idsToDelete)
        if (checkApiStatus(response)) {
            toggleLoader("buttonLoader", false)
            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
            return response
        } else {
            toggleLoader("buttonLoader", false)
            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
            return null
        }
    };
    const getClaim = async (shopVisitSlug) => {
        toggleLoader("pageLoader", true)
        const response = await globalGetService(getShopVisitApi(shopVisitSlug))
        if (checkApiStatus(response)) {
            toggleLoader("pageLoader", false)
            return response?.data?.data
        } else {
            toggleLoader("pageLoader", false)
            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
            return null
        }
    }
    const uploadFiles = async (shopVisitSlug, attachedFiles, getResponseBack) => {
        let formData = new FormData();
        if (attachedFiles?.length) { attachedFiles.map(item => { formData.append('files', item) }) }
        globalPostService(claimFileUploadPostApi(shopVisitSlug), formData)
            .then(response => {
                if (checkApiStatus(response)) {
                    getResponseBack();
                    // enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
                } else {
                    // enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
                }
            })
    };
    return { saveClaim, uploadFiles, deleteClaimFnc, getClaim };
}